import axios from 'axios';
import { getCookie } from '@/utils/getCookie';

const useSecureFetcher = async (
  route: string,
  data: unknown = null, // Default data is null for GET requests
  method = 'POST', // Default method is POST
) => {
  const jwt = getCookie('jwt');
  const userRole = getCookie('userRole');
  const apiLink = process.env.NEXT_PUBLIC_BASE_URL;

  try {
    if (jwt && userRole) {
      const headers = {
        Authorization: `Bearer ${jwt}`,
      };

      const config: any = {
        method,
        url: `${apiLink}/${route}`,
        headers,
        withCredentials: true,
      };

      // If it's a POST or PATCH request, add the data
      if (['get', 'post', 'put', 'patch', 'delete'].includes(method.toLowerCase())) {
        config.data = data;
      } else if (method.toLowerCase() === 'get') {
        // For GET request, data is usually passed as params
        config.params = data; // Assuming `data` is a query object for GET requests
      }

      // Send the request
      const response = await axios(config);

      return response.data;
    } else {
      // If JWT or UserRole is not present, clear cookies and localStorage
      localStorage.removeItem('userInfo');
      document.cookie = 'userInfo=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = 'userEmail=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = 'userRole=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = 'userPhone=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      throw new Error('Unauthorized: JWT is missing');
    }
  } catch (error) {
    return { error, status: 'error' };
  }
};

export default useSecureFetcher;
